import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 px-4 bg-beige" data-id="element-137">
      <div className="max-w-6xl mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-139">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-140">
            The Nervous System Solution
          </h2>
          <p className="text-2xl md:text-3xl text-sage font-serif italic" data-id="element-141">
            What if you could manually "flip the switch" from Alert to Safe?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-12" data-id="element-142">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl max-w-3xl mx-auto" data-id="element-143">
            <img src="https://cdn.magicpatterns.com/uploads/93SX8kZqj2emVUpwxaJ5wi/heylloyd-image-1771902253485.png" alt="The Nervous System Sleep Reset guide displayed on a tablet in a peaceful nursery setting" className="w-full h-auto" data-id="element-144" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-3xl mx-auto text-center" data-id="element-145">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-146">
            Introducing The Nervous System Sleep Reset
          </h3>
          <div className="prose prose-lg md:prose-xl mx-auto text-charcoal/80 mb-10" data-id="element-147">
            <p className="leading-relaxed mb-6" data-id="element-148">
              This isn't a book about routine. It's a tactical manual for the
              Vagus Nerve. By using specific touch-points, rhythmic pressures,
              and the "Head-Last" protocol, you can bypass the survival alarm
              and move your baby to the crib without them ever knowing you left.
            </p>
          </div>
          <CTAButton size="large" data-id="element-149">Learn the Protocol</CTAButton>
        </motion.div>
      </div>
    </section>;
}